export default {
    public:{
        subject: '学科',
        author: '作者',
        select: '筛选',
        item:'条',
        keywords: '关键词',
        load:'加载中...',
        nodata:'暂无数据',
        close:'收起',
        all:'全部',
        cancel:'取消',
        traditionalChinese:'繁体中文',
        thai:'泰语',
        indonesian:'印尼语',
        malay:'马来语',
        filipino:'菲律宾语',
        successful:'注册成功',
        loginTips: '请登录个人账号',
        loginSuccess: '登录成功',
        library:'ChatAnswer图书馆AI参考咨询系统',
        fellows:'ChatFellows机构内同行发现/引用系统',
        research:'ChatResearch高效个性化的学术探究平台',
        language:'ChatLanguage多语种AI智能翻译与语法校对系统',
        document:'ChatDocuments深度文档解析工具',
        data:'ChatData深度表格解析工具',
        other:'其他',
        feedSuccess:'问题反馈成功！',
        codeTips:'验证码已发送,请注意查收!',
        overtime:'请求超时'
    },
    header:{
        feedback:'问题反馈',
        quit:'退出登录',
        personal:'登录个人账号',
        language:'输出语言',
        username:'用户名',
        password:'密码',
        log:'登录',
        noRegistered:'未注册账号',
        register:'注册',
        personalAccount:'注册个人账号',
        accountUsername:'账号/用户名',
        tips:'请输入账号/用户名',
        tipsPassword:'请输入密码',
        confirmPassword:'确认密码',
        tipsConfirmPassword:'请再次确认密码',
        email:'邮箱',
        tipsEmail:'请输入邮箱',
        phone:'手机号',
        tipsPhone:'请输入手机号',
        verificationCode:'手机验证码',
        tipsVerificationCode:'请输入手机验证码',
        sendVerificationCode:'获取',
        back:'返回',
        module:'功能模块',
        selectTip:'请选择存在问题的功能模块',
        question:'问题描述',
        screenshot:'问题截图',
        upload:'点击上传',
        type:'仅支持上传.jpg/.png 格式',
        passwordTip:'请输入6-24位密码',
        enterAgain:'请再次输入密码',
        inconsistent:'两次输入密码不一致',
        enterCode:'请输入验证码',
        emailTip:'请输入正确的邮箱地址',
        enterEmail:'请输入邮箱地址',
        otherQuestion:'是否还有与此问题类似的其他疑问',
        example:'例如',
        bibliography:'图书馆书目',
        logOut:'确定退出账号吗',
        sure:'确定',
        switching:'切换多语言成功',
        again:'秒后重新发送',
        again2:'',
        hello:'你好',
    },
    login:{
        log:'登 录',
        institutionalLogin:'机 构 登 录',
        personalLogin:'个 人 登 录',
        accountRegistration:'账号注册',
        retrievePassword:'找回密码',
        usernameTip:'请输入机构用户名',
        personal:'请输入个人用户名',
        forget:'忘记密码？',
        ipLog:'IP 登录',
        institutional:'机构',
        institutionalTip:'请选择机构',
        country:'国家',
        countryTip:'请选择国家',
        invitationCode:'邀请码',
        codeTip: '请输入邀请码',
        newPass:'新密码',
        newPassTip:'请输入新密码',
        elmaiCode:'邮箱验证码',
        elmaiTip:'请输入邮箱验证码',
        resetting:'重置密码',
        logTip: '机构用户名不能为空',

        truePhone:'请输入正确的手机号',
        successful:'账号注册成功,请重新登录!',
        passwordReset:'密码重置成功,请重新登录!',
        noteTitle:'获取验证码注意事项：',
        noteOne:'1.为了确保验证码能够及时且准确地送达，我们建议使用以下邮箱服务商：Gmail、Outkook、Yahoo；',
        noteTwo:'2.由于各邮件服务商的过滤机制，有时验证码邮件可能会被误判为垃圾邮件或无效邮件，请检查验证码邮件是否存在垃圾邮件回收站中。',
    },

    chatlibrary: {
        questionOne: '查询图书馆借阅方面的问题',
        questionTwo: '查询已购数据库相关问题',
        questionThree: '查询图书馆数字资源相关问题',
        quickAccess: '快捷访问',
        disclaimer: '免责声明',
        further:'进一步提问',
        goon:'继续',
        statementOne: '1.ChatAnswer的回复内容基于常见问题回复与相关资源公开信息，实际内容以图书馆官方公布信息、来源资源官方内容为准。',
        statementTwo: '2.翻译功能的翻译结果仅供参考，平台对依赖网站翻译信息的准确性或可靠性所造成的任何损失不承担任何责任；译文中的内容仅代表原文作者观点，不代表平台观点与看法，与平台开发方立场无关。',
        statementThree: '3.语法校对功能仅基于内容的语言学语法问题进行校对，不能达到人工语言润色的水平，平台对过度依赖语法校对结果所造成的任何损失不承担任何责任。',
        statementFour: '4.如读者依据相似性推荐结果进行刊物投稿，投稿前需再次确认期刊信息并与编辑部联系，对盲目依赖网站提供信息造成的任何损失不承担任何责任',
        statementFive: '5.读者上传的问题、检索需求、文本、文件的内容中的观点，不代表平台观点与看法，与平台开发方立场无关。',
        // 手机端
        statementOneMobile: '1.ChatAnswer的回复内容基于常见问题回复与相关资源公开信息，实际内容以图书馆官方公布信息、来源资源官方内容为准。',
        statementTwoMobile: '2.翻译功能的翻译结果仅供参考，平台对依赖网站翻译信息的准确性或可靠性所造成的任何损失不承担任何责任；译文中的内容仅代表原文作者观点，不代表平台观点与看法，与平台开发方立场无关。',
        statementThreeMobile: '3.语法校对功能仅基于内容的语言学语法问题进行校对，不能达到人工语言润色的水平，平台对过度依赖语法校对结果所造成的任何损失不承担任何责任。',
        statementFourMobile: '4.如读者依据相似性推荐结果进行刊物投稿，投稿前需再次确认期刊信息并与编辑部联系，对盲目依赖网站提供信息造成的任何损失不承担任何责任',
        statementFiveMobile: '5.读者上传的问题、检索需求、文本、文件的内容中的观点，不代表平台观点与看法，与平台开发方立场无关。',

        // 进入弹窗文本
        hellow: '你好：欢迎你的咨询，我是',
        introduceOne: '智能AI助手ChatAnswer，很高兴为你服务。',
        introduceTwo: '1. 图书馆的开放时间',
        introduceThree: '2. 如何查找数字资源？',
        introduceFour: '3. 如果所借阅的图书不慎丢失，怎么办？',
        introduceFive: '4. 介绍一下医学相关的数据库',
        introduceSix: ' 5. 如何在校外访问图书馆数字资源？',
        introduceSeven: '你可以问我有关图书馆的问题，比如你可以问我“如何查询和找到需要的图书？”"图书馆开馆时间""图书的借阅规则"等，我会尽可能回答你；还有关于图书、数据库和图书馆其他服务等方面我们也可以进行解答，比如：',
        questions: '进一步提问',
        Continue:'继续',
        recording:'鼠标点击录音',
        stopRecording:'鼠标点击停止录音',
        microphone:'请先允许该网页使用麦克风',
        browserTips:'您的浏览器不支持语音识别',
        browserTips2:'您的浏览器不支持识别声音大小',
        progress:'语音识别中...',
        failed:'语音识别失败',
    },
    chatresearch: {
        theme: 'ChatResearch | 基于语义的深度发现',
        themeMobile: '基于语义的深度发现',
        switchSemantics: '切换语义检索',
        switchTraditional: '切换传统检索',
        title: '标题',
        results:'精选结果',
        source: '来源',
        year: '发表年份',
        abstract: '摘要',
        tips: '请输入检索内容...',
        select: '请选择',
        issn: 'ISSN',
        introduce_tit: '平台介绍',
        introduceOne: 'ChatResearch将利用人工智能和先进技术为读者提供更加全面、个性化与高效的学术探究平台，核心功能包括：',
        introduceTwo: '跨语种语义搜索系统：通过深度理解读者的搜索意图与兴趣，以及跨语言知识映射，ChatResearch平台的跨语种语义搜索系统将提供更全面、更精准的搜索结果。',
        introduceThree: '批量文献管理：批量文献管理工具可帮助研究人员、学者等群体快速处理大量文献内容，可对文献进行分类、标注、搜索、筛选、批注、下载及多种自动化功能，从而大幅提升文献管理与科研工作的效率。',
        search:'传统逻辑检索',
        searchAll:'搜索全部',
        searchTip:'您可将摘要全文、来自文献的段落或详细描述文字作为检索内容，系统能够实现基于语义相似度比对的语义检索，输入内容篇幅越长，匹配效果越精确。',
        clear:'清空搜索',
        link:'文章链接',
        Similar:'相似文献',
        followingresults:'搜索以下结果',
        chinese:'中文',
        english:'英文',
        total:"返回结果总量",
        introduceFour:'基于语义分析与相似度匹配的学科发现系统，可以实现跨语种高效、智能检索',
        volume:'请选择检索量',
        
        inputTips:'当前输入框内容不能为空！'
    },
    chatlanguage: {
        enter: '输入',
        errorChecking: '英文查找语法错误',
        CToE: '中译英',
        EToC: '英译中',
        docTran: '译采文档翻译',
        functionIntroduction: '功能介绍',
        introduceOne: '您可以使用“英文查找语法错误”功能对英语文本内容进行智能语法校对。输入内容后，系统能够实现智能识别并纠正论文中的语法问题，支持对句式、势态、主谓用法、标点等类型问题的校正，辅助提高文章质量，增强可读性与表达准确性。',
        introduceTwo: '您可以使用“英语学术润色”功能对英语文本进行润色与优化。系统会从流畅性和优美性的角度出发，对文本进行修改，使其更加通顺、精炼。为文本增添专业魅力，使得主题思想更为清晰地展现。',
        tips: '请输入查询内容',
        basic:'基础功能',
        polish:'英语学术润色',
        inputTips:'请输入需要校对或是润色的文本内容',

        againRequest:'请求失败!请重试!',
    },
    chatfellows:{
        introduceOne:'成果智能发现平台 —— 站在前辈肩膀上',
        introduceTwo:'平台简介',
        introduceThree_one:'ChatFellows',
        introduceThree_two:'成果智能发现平台是一款专为',
        introduceThree:'科研人员打造的智能学术检索工具。基于机构成果的全面集成，应用语义相似度计算、向量化技术、自然语言感知等技术，实现成果的深层次、多维度利用，实现智能精准的结果匹配、相似度排序，并实现跨语种检索与匹配，有效协助科研人员开展学术文献调研、参考文献检索、投稿期刊选择等科研发文工作的开展。',
        introduceFour:'成果智能发现平台全面集成汇聚了我校重点研究成果，通过智能AI技术的深层应用，实现成果的有效应用，辅助科研工作的有效开展。致力于帮助用户快速准确地找到相关领域的优质论文，提高研究效率，助力学术成果的取得。站在巨人肩膀上，不断推动学术研究的持续进步。',
        introduceFive:'核心功能',
        introduceSix:'智能匹配检索：实现我校重要评价来源成果中相似论文的高效发现。',
        introduceSeven:'跨语种检索：通过向量化技术的应用，实现检索与匹配不受语言限制。',
        introduceTen:'相似度优化排序：根据论文的相似度呈现最优匹配结果，方便科研读者快速定位最为相关的研究成果。',
        introduceEight:'详细信息展示：平台提供检索结果详细的文献信息及外文成果的摘要译文，便于用户快捷了解成果主旨。',
        introduceNine:'高时效性更新：平台定期同步重要评价来源数据库，确保读者能够掌握最新的成果动态。',
        knowBtn:'我知道了',
        enter:'输入',
        title:'成果智能发现平台——站在前辈肩膀上',
        tips:'请您输入需要查询文章的摘要或主题(篇名、关键词等) ，系统会帮您查找重点评价来源中我校的相似论文(中文无需专门翻译转换! )',
        submit:'提交',
        relatedLiterature:'相关文献',
        year:'年份',

        enSummary:'英文摘要',
        cnSummary:'中文摘要',
    },
    chatdocument:{
        title:'深度文档解析工具',
        introduce:'实现指定主题、范围的文档数据内容提取和全文解析，从而辅助开展深度研究。',
        start:'开始体验',
        ask:'文档提问，获取你需要的答案',
        createSession:'创建会话，同时提问多个文档',
        quoting:'引用段落，深度解析文献内容',
        analyze:'解析图表，提取数据全面解析',
        tool:"高效率文档解析助手",
        list:'文献列表',
        conversation:'会话列表',
        createAsk:'创建会话',
        upload:'文件上传',
        drag:'拖入文件或点击上传',
        introduceOne:'提问文档内容，通过聊天的形式即时获取答案。',
        introduceTwo:'ChatDocuments是一个文件解析助手，可以快速从文档中提取，定位和综述信息。',
        quick:'快捷访问',
        enter:'请输入内容...',
        askQuestion:'提问',
        example:'示例',
        busy:'服务繁忙，请重试',
        stop:'停止回答',
        onlyAsk:'仅对当前文章提问',
        chapter:'篇',
        create:'创建',
        editsession:'编辑会话',
        sessionname:'会话名称',
        currentlyselected:'当前已选择',
        fileselection:'文件选择',
        revise:'修改',
        docLanguage:'文档语言',
        zhDoc:'中文文档',
        enDoc:'英文文档',
        support:'*仅支持上传pdf文件',
        nowUpload:'正在上传，请稍后...',
        question:'文档语言不符合，无法选择',
        editTitle:'双击编辑文件名称',

        uploadSuccess:'上传成功',
        sideBar:'收缩侧边栏',
        noData:'文档中没有找到可解析的表格',
        delConfirm:'确定删除该文件吗?',
        unable:'无法对该excel进行解析',
        delSuccess:'删除成功',
        selFile:'请选择文件',
        inputName:'请输入会话名称',
        createSuccess:'创建成功',
        fileTips:'该文件正在转换中，请稍后再试',
        failFile:'该文件转换失败，请重新上传',
        defaultQuestion1:'表格中包含了哪些字段，描述了什么数据？',
        defaultQuestion2:'请计算出每列数据的平均值？',
        defaultQuestion3:'请计算出每列数据的中位数？',
        defaultQuestion4:'每列数据中出现次数最多的数值是？',
        defaultQuestion5:'从表格的数据中我们可以得到哪些信息，通过分析我们可以得到什么结论？',
    },
    chatdata:{
        title:'深度数据智能分析工具',
        introduce:'通过智能解析和深度分析，为您揭示数据中的见解。利用可视化分析功能，实现图表形式的生动展现。',
        start:'开始体验',
        ask:'文档提问，获取你需要的答案',
        create:'创建会话，同时提问多个文档',
        quoting:'引用段落，深度解析文献内容',
        analyze:'解析图表，提取数据全面解析',
        tool:"高效率文档解析助手",
        list:'文献列表',
        conversation:'会话列表',
        createAsk:'创建会话',
        upload:'文件上传',
        drag:'拖入文件或点击上传',
        introduceOne:'ChatData通过对表格及数据集的智能解析，可以实现与表格进行对话式的提问。并且通过深度分析可自动生成可视化图表，让数据一目了然！',
        quick:'快捷访问',
        enter:'请输入内容...',
        hint:'提示',
        hintOne:'请先该模块功能维护中，暂时无法使用，感谢您的理解和耐心等待选择文件',
        Isee:'我知道了',
    },
    chatopen:{
        title:'你的开放知识探索引擎',
        switch:'切换传统检索',
        introduce:'获取发现物理学、数学、计算机科学、人工智能、统计学等最新科研成果，把握发展趋势',
        features:'产品特点',
        featureOne:'利用人工智能和先进技术为科研人员提供更加高效、强大、精准的知识发现体验。ChatOpen应用了语义检索技术，实现深度理解读者的搜索意图、兴趣与跨语言只是映射。',
        featureTwo:'集成海量开放知识元数据，为科研读者提供包括开放获取文献、预印本、等在内的多类型开源学术成果.结合语义发现，我们希望这些资源能够助您推动学术科研创新，连接您与开放的未来。',
        translate:'翻译',
        clear:'清空筛选'
    },
    message:{
        authority:"暂无权限",
        upload:"仅支持上传 .jpg/.png 格式!",
        apply:"试用申请已提交,请耐心等待!",
        delete:"确定删除该文件吗?",
        size: '文件大小不能超过 20MB',
        wait:'正在处理中，请稍后'
    }
}
